module.exports = __webpack_public_path__ + "static/media/kid26.a1182c50.png";